import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";

const SessionChart = ({ values, nurseData, patientData, physioData }) => {
  const getOptions = () => {
    let totalCounts = [];
    let categories = [];
    const today = moment();

    switch (values) {
      case "Today": {
        // For Today, display hourly data
        totalCounts = Array.from({ length: 24 }, (_, i) => {
          const hour = i;
          return (
            nurseData.filter((entry) => moment(entry.lastLogin).hour() === hour)
              .length +
            patientData.filter(
              (entry) => moment(entry.lastLogin).hour() === hour
            ).length +
            physioData.filter(
              (entry) => moment(entry.lastLogin).hour() === hour
            ).length
          );
        });

        categories = Array.from({ length: 24 }, (_, i) =>
          today.startOf("day").add(i, "hours").format("HH:00")
        );
        break;
      }

      case "Last 7 days": {
        // For the last 7 days, display daily data
        totalCounts = Array.from({ length: 7 }, (_, i) => {
          const day = today
            .clone()
            .subtract(6 - i, "days")
            .format("YYYY-MM-DD");
          return (
            nurseData.filter(
              (entry) => moment(entry.lastLogin).format("YYYY-MM-DD") === day
            ).length +
            patientData.filter(
              (entry) => moment(entry.lastLogin).format("YYYY-MM-DD") === day
            ).length +
            physioData.filter(
              (entry) => moment(entry.lastLogin).format("YYYY-MM-DD") === day
            ).length
          );
        });

        categories = Array.from({ length: 7 }, (_, i) =>
          today
            .clone()
            .subtract(6 - i, "days")
            .format("ddd, MMM D")
        );
        break;
      }

      case "Last 30 days": {
        // For the last 30 days, display daily data
        totalCounts = Array.from({ length: 30 }, (_, i) => {
          const day = today
            .clone()
            .subtract(29 - i, "days")
            .format("YYYY-MM-DD");
          return (
            nurseData.filter(
              (entry) => moment(entry.lastLogin).format("YYYY-MM-DD") === day
            ).length +
            patientData.filter(
              (entry) => moment(entry.lastLogin).format("YYYY-MM-DD") === day
            ).length +
            physioData.filter(
              (entry) => moment(entry.lastLogin).format("YYYY-MM-DD") === day
            ).length
          );
        });

        categories = Array.from({ length: 30 }, (_, i) =>
          today
            .clone()
            .subtract(29 - i, "days")
            .format("MMM D")
        );
        break;
      }

      case "Over All": {
        // For Overall, display total data for all available dates
        const allData = [...nurseData, ...patientData];
        const uniqueDates = [
          ...new Set(
            allData.map((entry) => moment(entry.lastLogin).format("YYYY-MM-DD"))
          ),
        ];
        uniqueDates.sort((a, b) => moment(a).diff(moment(b)));

        totalCounts = uniqueDates.map((date) => {
          return (
            nurseData.filter(
              (entry) => moment(entry.lastLogin).format("YYYY-MM-DD") === date
            ).length +
            patientData.filter(
              (entry) => moment(entry.lastLogin).format("YYYY-MM-DD") === date
            ).length
          );
        });

        categories = uniqueDates.map((date) => moment(date).format("MMM D"));
        break;
      }

      default:
        break;
    }

    return {
      chart: {
        backgroundColor: "#fff",
        borderRadius: 10,
        height: 240,
        style: {
          fontFamily: "'Arial', sans-serif",
        },
        plotBorderColor: "#606063",
      },
      title: {
        text: "",
        style: {
          color: "#333",
          fontWeight: "bold",
          fontSize: "12px",
        },
      },
      xAxis: {
        categories,
        labels: {
          style: {
            color: "#474747",
            fontSize: "10px",
          },
        },
        lineColor: "#D7E4EB",
        lineWidth: 1,
        tickColor: "#333",
        gridLineColor: "#e6e6e6",
        gridLineDashStyle: "dot",
        gridLineWidth: 1.5,
      },
      yAxis: {
        title: {
          text: "",
        },
        labels: {
          style: {
            color: "#474747",
            fontSize: "12px",
          },
        },
        gridLineColor: "#fff",
      },
      series: [
        {
          name: "Total",
          data: totalCounts,
          type: "line",
          color: "#17EB5F",
          lineWidth: 1.2,
          marker: {
            enabled: false,
          },
        },
      ],
      tooltip: {
        shared: true,
        crosshairs: true,
        backgroundColor: "rgba(255, 255, 255, 0.85)",
        borderColor: "#ccc",
        style: {
          color: "#333",
          fontSize: "12px",
        },
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
    };
  };

  return (
    <div className="p-2">
      <HighchartsReact highcharts={Highcharts} options={getOptions()} />
    </div>
  );
};

export default SessionChart;
